import { Base } from '@gate31/core/src/libs/BaseComponent';
import { LoginAccountEmail } from '@gate31/feature/LoginAccountEmail/LoginAccountEmail';

export class LoginAccountEmailDesk extends LoginAccountEmail {
    static cn = new Base.BuildCn('LoginAccountEmailDesk');
}
